import React from 'react'
import 'url-search-params-polyfill';
import { loadRegions, setFlagsCity, setFlagsRegion } from '../../store/filters'
import { connect } from 'react-redux'
import { IndexLink, withRouter } from 'react-router'
import Checkbox from 'material-ui/Checkbox'

class Filters extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLogged: this.props.isLogged,
            filterCities: this.props.filterCities,
            filterRegions: this.props.filterRegions,
            cities: this.props.cities,
            regions: this.props.regions
        };

        this.props.loadRegions(resp => {

        });
    };


    componentWillReceiveProps(nextProps) {
        this.setState({
            isLogged: nextProps.isLogged,
            cities: nextProps.cities,
            regions: nextProps.regions,
            filterCities: nextProps.filterCities,
            filterRegions: nextProps.filterRegions
        });
    };

    getRegionByCity(city) {
        const obj = this.state.filterCities.find(i => i.name === city);
        return obj ? obj.region_id : null;
    }

    selectCity = (e) => {
        let cities = this.state.cities;
        let val = e.target.value;
        let index = cities.indexOf(val);
        if (e.target.checked && index === -1) {
            cities.push(val);
        } else {
            if (index > -1) {
                cities.splice(index, 1);
            }
        }

        let url = new URLSearchParams(this.props.location.search);
        let category_id = url.get('category_id');
        let goTo = category_id ? `/deals?category_id=${category_id}` : `/deals`;

        if (cities.length > 0) {
            const regionId = this.getRegionByCity(val);
            goTo = category_id ? `/deals?cities[]=${cities.join('&cities[]=')}&category_id=${category_id}` : `/deals?cities[]=${cities.join('&cities[]=')}`;
            if (regionId) {
                goTo += `&regions[]=${regionId}`;
            }
        }
        this.props.router.push(goTo);
        this.props.setFlagsCity(cities);
    };

    selectRegion = (e) => {
        let regions = this.state.regions;
        let val = e.target.value;
        let index = regions.indexOf(val);
        if (e.target.checked && index === -1) {
            regions.push(val);
        } else {
            if (index > -1) {
                regions.splice(index, 1);
            }
        }

        let url = new URLSearchParams(this.props.location.search);
        let category_id = url.get('category_id');
        let goTo = category_id ? '/deals?category_id=' + category_id : '/deals';

        if (regions.length > 0) {
            goTo = category_id ? '/deals?regions[]=' + regions.join('&regions[]=') + '&category_id=' + category_id : '/deals?regions[]=' + regions.join('&regions[]=');
        }
        this.props.router.push(goTo);
        this.props.setFlagsRegion(regions);
    };

    render() {

        let showCities = false;
        if (this.state.isLogged && this.state.filterCities.length > 0) {
            showCities = true;
        }

        let listItems = '';
        if (showCities) {
            listItems = this.state.filterCities.map((item, index) => {
                return (
                    <li key={index}>
                        <Checkbox
                            value={item.name}
                            label={item.name + ' (' + item.count + ')'}
                            onCheck={this.selectCity}
                            checked={this.state.cities.indexOf(item.name) > -1}
                            style={{ display: 'block' }}
                        />
                    </li>
                );
            });
        } else {
            listItems = this.state.filterRegions.map((item, index) => {
                return (
                    <li key={index}>
                        <Checkbox
                            value={item.id}
                            label={item.name + ' (' + item.count + ') '}
                            onCheck={this.selectRegion}
                            checked={this.state.regions.indexOf(item.id.toString()) > -1}
                            style={{ display: 'block' }}
                        />
                    </li>
                );
            });
        }

        return (
            <div>
                <h5 className="sidebar-menu-title">{showCities ? 'Cities' : 'Regions'}</h5>
                <ul className="sidebar-menu cities-list">
                    {listItems}
                </ul>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        isLogged: state.token ? true : false,
        filterRegions: state.filterRegions,
        filterCities: state.filterCities,
        cities: state.searchCityParams,
        regions: state.searchRegionParams
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadRegions: (callback) => dispatch(loadRegions(callback)),
        setFlagsCity: (val) => dispatch(setFlagsCity(val)),
        setFlagsRegion: (val) => dispatch(setFlagsRegion(val))
    }
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Filters))



// WEBPACK FOOTER //
// ./src/components/categories/Filters.js